import AddressInfo from './addressInfo';

export default function Branch(data) {
    let branch = data || {};
    this.id = branch.id;
    this.name = branch.name;
    this.description = branch.description;
    this.address = new AddressInfo(branch.address);
    this.geo = branch.geo;
    this.url = branch.url;
    this.image = branch.image;
    this.email = branch.email;
    this.insuranceType = branch.insuranceType !== undefined ? branch.insuranceType : [];
}